import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { locationShape } from 'react-router'

import { pageLoaded, fetchEvent } from 'src/actions'

import { hostSelector, eventSelector, eventTokenSelector, eventModalSelector } from 'src/selectors'

import DashboardContainer from 'src/containers/DashboardContainer'
import Flier from 'src/components/details/Flier'
import RSVPModalContainer from 'src/components/rsvp_modal/RSVPModalContainer'
import ImageModalContainer from 'src/components/modals/ImageModalContainer'
import ToastMessagesContainer from 'src/components/global/ToastMessagesContainer'
import EventSectionsContainer from 'src/containers/EventSectionsContainer'
import NoticeYellow from 'src/assets/icons/ico-notice-yellow.png'
import cn from 'classnames'
import HobnobModal from 'components/common/HobnobModalV2/HobnobModal'
import Button from 'components/common/Button'
import { changeRefreshModal } from 'src/actions/event'
import LoadingComponent from 'components/common/LoadingComponent/LoadingComponent'
import { routerActions } from 'react-router-redux'

import styles from './guest-event.scss'

// Receives event. Displays it for a guest
class GuestEvent extends React.Component {
  componentDidMount() {
    this.props.dispatch(pageLoaded())
    setTimeout(() => {
      this.verifyFlier()
    }, 5000)
  }

  verifyFlier = () => {
    this.props.dispatch(
      fetchEvent(this.props.event.id, data => {
        const event = data.event
        if (event.flyer?.state === 'pending' || event.state === 'activation_pending_flier') {
          console.log(event.pending_flyer)
        }
      })
    )
  }

  _renderDraftNotice = () => {
    return (
      <div className={styles['draft-notice']}>
        <img src={NoticeYellow} width="20" />
        <span>
          This is a draft preview, activate it to send your invite! (you can edit it anytime)
        </span>
      </div>
    )
  }

  _renderFlier = () => {
    const { event, dispatch, eventToken } = this.props
    if (event.flyer === null) {
      return <LoadingComponent type="partial" loading light />
    }

    if (event.flyer?.state === 'pending' || event.state === 'activation_pending_flier') {
      return (
        <div className={styles['flyer-empty-container']}>
          <h3>Flyer upload failed. Please try again.</h3>
          <Button onClick={() => dispatch(routerActions.push(`/e/edit/${eventToken}`))}>
            SELECT FLYER
          </Button>
        </div>
      )
    }

    return <Flier event={event} />
  }

  render() {
    const { dispatch, location, event, visibleRefreshModal, eventModal } = this.props

    const isDraft = event.state === 'draft'

    return (
      <DashboardContainer
        menuIcon
        visibleHeaderBar={eventModal === 'details'}
        documentTitle={event.name}
      >
        <>
          {isDraft && this._renderDraftNotice()}

          <div
            className={cn(styles['guest-event-container'], {
              [styles['guest-event-container-draft']]: isDraft
            })}
          >
            <div className={styles['guest-flier-container']}>{this._renderFlier()}</div>
            <div className={styles['information']}>
              <EventSectionsContainer location={location} />
              <RSVPModalContainer />
              <ImageModalContainer />
              <ToastMessagesContainer />
            </div>
          </div>

          <HobnobModal
            visible={visibleRefreshModal}
            onCancel={() => dispatch(changeRefreshModal(false))}
          >
            <div className={styles['refresh-container']}>
              <div className={styles['title']}>
                Your Host has changed the settings of this event. Please refresh the page to RSVP.
              </div>
              <Button className={styles['button-inner']} onClick={() => window.location.reload()}>
                REFRESH
              </Button>
            </div>
          </HobnobModal>
        </>
      </DashboardContainer>
    )
  }
}

GuestEvent.propTypes = {
  eventToken: PropTypes.string,
  eventModal: PropTypes.string,
  visibleRefreshModal: PropTypes.bool,
  dispatch: PropTypes.func,
  event: PropTypes.object,
  location: locationShape
}

function mapStateToProps(state) {
  return {
    host: hostSelector(state),
    event: eventSelector(state),
    eventToken: eventTokenSelector(state),
    visibleRefreshModal: state.frontend.visibleRefreshModal,
    eventModal: eventModalSelector(state)
  }
}

export default connect(mapStateToProps)(GuestEvent)
